module.exports = __webpack_public_path__ + "img/device_point5-3.a6e91b3d.png";